import React from 'react'
import { Route, BrowserRouter as Router, Routes, Link  } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import config from '../Config';

export const Banner = () => {
  return (
    <>
    <section className='banner-bg bg-transparentcustm bg-salem'>
      <img className='banr-nwdots' src={`${config.siteBaseUrl}/assets/imgs/our-integrations-bannerbg.svg`} alt='' />
      
        <Container>
           <Row>
            <Col xs="12" lg="12" className='text-left'>
            <span><img src={`${config.siteBaseUrl}/assets/imgs/sellsheet-icon.svg`} alt='' />SALES MATERIALS</span>
            <h1>Download your TCB Pay Sales Kit</h1>
            </Col>
            <Col xs="12" lg="7" className='text-left'>
            <p>Download our brochures, sell sheets, and product one-pagers to better understand what TCB Pay offers — from corporate cards to embedded payment solutions.</p>
            
            </Col>
          </Row>  
        </Container>
    </section>
    </>
  )
}
